document.addEventListener('click', function(e) {
  const button = e.target.closest('.mosaic-video-button');
  if (!button) return;

  const block = button.closest('.mosaic-new-video-block');
  if (!block) return;

  const videos = block.querySelectorAll('video.mosaic-video');
  let video;
  videos.forEach(function(v) {
    if (v.offsetParent !== null) video = v;
  });
  if (!video) return;

  const playIcon = button.querySelector('.mosaic-video-play-button');
  const pauseIcon = button.querySelector('.mosaic-video-pause-button');

  if (video.paused) {
    video.play();
    video.controls = true;
    playIcon.classList.add('hidden');
    pauseIcon.classList.remove('hidden');
  } else {
    video.pause();
    video.controls = false;
    playIcon.classList.remove('hidden');
    pauseIcon.classList.add('hidden');
  }
});



document.addEventListener('click', function(e) {
  const muteControl = e.target.closest('.video-mute-control-block');
  if (!muteControl) return;

  const block = muteControl.closest('.video-text-block');
  if (!block) return;

  const videos = block.querySelectorAll('video.video-text-video');
  let video;
  videos.forEach(function(v) {
    if (v.offsetParent !== null) video = v;
  });
  if (!video) return;

  const muteBtn = muteControl.querySelector('.mute-button');
  const unmuteBtn = muteControl.querySelector('.unmute-button');

  video.muted = !video.muted;

  muteBtn.classList.toggle('active', video.muted);
  unmuteBtn.classList.toggle('active', !video.muted);
});

function initAutoplayMutedVideos(selector) {
  var videos = document.querySelectorAll(selector);

  videos.forEach(function(video) {
    video.muted = true;
    video.play().catch(function() {});
  });

  function unmute() {
    videos.forEach(function(video) {
      video.muted = false;
      video.play().catch(function() {});
    });
    document.removeEventListener('click', unmute);
    document.removeEventListener('touchstart', unmute);
  }

  document.addEventListener('click', unmute, { once: true });
  document.addEventListener('touchstart', unmute, { once: true });
}

initAutoplayMutedVideos('.mosaic-video');
initAutoplayMutedVideos('.video-text-video');

// document.querySelectorAll('.mosaic-video').forEach(function(video) {
//   video.muted = true;
//   video.play().catch(function() {});
// });

// function unmuteMosaicVideos() {
//   document.querySelectorAll('.mosaic-video').forEach(function(video) {
//     video.muted = false;
//     video.play().catch(function() {});
//   });
//   document.removeEventListener('click', unmuteMosaicVideos);
//   document.removeEventListener('touchstart', unmuteMosaicVideos);
// }

// document.addEventListener('click', unmuteMosaicVideos, { once: true });
// document.addEventListener('touchstart', unmuteMosaicVideos, { once: true });


// document.querySelectorAll('.video-text-video').forEach(function(video) {
//   video.muted = true;
//   video.play().catch(function() {});
// });

// function unmuteVideoTextVideos() {
//   document.querySelectorAll('.video-text-video').forEach(function(video) {
//     video.muted = false;
//     video.play().catch(function() {});
//   });
//   document.removeEventListener('click', unmuteVideoTextVideos);
//   document.removeEventListener('touchstart', unmuteVideoTextVideos);
// }

// document.addEventListener('click', unmuteVideoTextVideos, { once: true });
// document.addEventListener('touchstart', unmuteVideoTextVideos, { once: true });